<template>
  <li class="el-dropdown-menu__item screenfull-svg" @click="click">
    <font-awesome-icon :icon="['fas', 'expand-arrows-alt']" />
    Fullscreen
  </li>
</template>

<script>
import screenfull from 'screenfull'

export default {
  name: 'Screenfull',
  props: {
    fill: {
      type: String,
      default: '#48576a'
    },
    target: {
      default: null
    }
  },
  data() {
    return {
      isFullscreen: false
    }
  },
  methods: {
    click() {
      if (!screenfull.enabled) {
        this.$message({
          message: 'you browser can not work',
          type: 'warning'
        })
        return false
      }
      if ( this.target ) {
        screenfull.toggle( document.getElementById( this.target ) )
      } else {
        screenfull.toggle()
      }
    }
  }
}
</script>

<style>
.screenfull-svg {
  /*display: inline-block;*/
  cursor: pointer;
  fill: #5a5e66;
}
</style>
